import { forbiddenQueryPatterns } from 'static/constants'
import { fromJS } from 'immutable'

const regularExpressions = {
  linkedinUrl: /^(https?:\/\/)?((www|[a-z]{2})\.)?linkedin.com\/[a-zA-Z0-9.?]/,
  twitterUrl: /^(https?:\/\/)?(www\.)?(twitter|x).com\/[a-zA-Z0-9.?]/,
  facebookUrl: /^(https?:\/\/)?(www\.)?facebook.com\/[a-zA-Z0-9.?]/,
  threadsUrl: /^(https?:\/\/)?(www\.)?threads.net\/@[a-zA-Z0-9.?]/,
  tiktokUrl: /^(https?:\/\/)?(www\.)?tiktok.com\/@[a-zA-Z0-9.?]/,
  instagramUrl: /^(https?:\/\/)?(www\.)?instagram.com\/[a-zA-Z0-9.?]/,
  youtubeUrl: /^(https?:\/\/)?(www\.)?youtube.com\/[a-zA-Z0-9.?]/,
  otherUrl: /^(https?:\/\/)?(www\.)?[^.]+.[^.]+/
}

const allowedChannels = Object.keys(regularExpressions)
const filterChannelUrls = data => data.filter((_value, key) => allowedChannels.includes(key))

export const isValidSocialMediaUrl = (key, url) => (url ? regularExpressions[key].test(url) : true)

export const checkAllUrls = d => filterChannelUrls(d).map((value, key) => ({
  key,
  valid: isValidSocialMediaUrl(key, value)
}))
export const getInvalidChannelUrls = d => checkAllUrls(d).filter(e => !e.valid)

export const isValidSearchQuery = query => {
  if (query && query.length < 3) {
    return false
  }

  if (query.trim() === 'NOT') {
    return false
  }

  return !forbiddenQueryPatterns.some(f => (query.match(f.pattern) || []).length > f.allowedCount)
}

export const validateQueryOnChange = (query, onSuccess) => {
  if (!query || isValidSearchQuery(query)) {
    onSuccess()
  }
}

export const validateQueryOnSubmit = (query, onSuccess, onError) => {
  if (!isValidSearchQuery(query)) {
    onError()
  } else {
    onSuccess()
  }
}

export const filterStateIdsByCountryIds = (selectedStateIds, selectedCountryIds, states) => {
  if (!selectedCountryIds.size) {
    return fromJS([])
  }

  return selectedStateIds.filter(stateId => {
    const state = states.find(s => s.get('id') === stateId)

    return selectedCountryIds.includes(state.get('countryId'))
  })
}
